<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">预定义审核流程</span>
      <div class="head-text" style="float: right; margin-top: -4px">
        <el-button
          type="danger"
          size="medium"
          style="float: right; margin-right: 10px"
          class="float-r-mar-r10"
          @click="DelFileWorkFlow('more')"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          size="medium"
          style="float: right; margin-right: 10px"
          class="float-r-mar-r10"
          @click="addActionFlow"
          >新建</el-button
        >
      </div>
    </div>
    <el-container>
      <el-main>
        <!-- 通用资料审核流程table -->
        <el-table
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          height="700px"
        >
          <el-table-column type="selection"> </el-table-column>
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column prop="pfwf03" label="名称"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="updateFlow(scope.row)"
                type="primary"
                size="mini"
                >修改</el-button
              >
              <el-button
                @click="CopyFileWorkFlow(scope.row)"
                type="primary"
                size="mini"
                >复制</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="DelFileWorkFlow('single', scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <!-- 增加，修改资料审核流程 -->
    <el-drawer
      title="流程环节详情"
      :visible.sync="addActionFlowVisible"
      direction="rtl"
      size="40%"
    >
      <el-form ref="form" :model="model" label-width="80px">
        <el-form-item label="审核名称">
          <el-input v-model="model.model.pfwf03"></el-input>
        </el-form-item>
        <i
          @click="addFlowDom()"
          class="el-icon-circle-plus-outline"
          style="
            font-size: 30px;
            color: green;
            float: right;
            margin-right: 20px;
          "
        ></i>
        <el-table :data="model.list" style="width: 100%">
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column prop="name" label="流程节点">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="审批人">
            <template slot-scope="scope">
              <el-select
                filterable
                v-model="scope.row.users"
                @change="changeUser"
                multiple
                @remove-tag="removetag"
              >
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  v-for="item in userList"
                  :key="item.user01"
                  v-show="item.isSelect === false"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="审批性质">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="item in examineType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i
                @click="deleteFlowDom(scope)"
                class="el-icon-remove-outline"
                style="font-size: 30px; color: red"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item>
          <el-button type="primary" @click="AddFileWorkFlow">{{
            this.type == "add" ? "立即创建" : "修改"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import dataManagement from "@/mixin/dataManagement";
export default {
  mixins: [dataManagement],
  data() {
    return {};
  },
  created() {
    // 判断是通用的还是个人的  通用下面两个值为0，个人为1
    this.model.model.pfwf05 = 0;
    this.globalType = 0;
    this.GetFileWorkFlow();
  },
  methods: {},
};
</script>

<style scoped lang = "less">
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
</style>